module.exports = __webpack_public_path__ + "static/media/findRecipe.61957797.png";